module.exports = __webpack_public_path__ + "static/media/Card-1.26448845.png";